<br />
<mat-card style="padding: 1rem; width: 98%; margin: auto">
  <div
    style="display: flex; align-items: flex-start; gap: 1rem; flex-wrap: wrap"
  >
    <div class="adjust-width common-drop">
      <div class="key">Channel :</div>
      <mat-form-field appearance="outline">
        <mat-select
          name="channel"
          [(value)]="selectedRetailer"
          placeholder="Channel"
          (selectionChange)="selectionChangeChannel($event.value)"
        >
          <mat-option
            *ngFor="let option of channelOption"
            [disabled]="option.disabled"
            [value]="option"
            >{{ option }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div class="adjust-width common-drop">
      <div class="key">Category :</div>
      <mat-form-field appearance="outline">
        <mat-select
          name="competitorSKU"
          [(value)]="selectedCategory"
          placeholder="Category"
          (selectionChange)="selectionCategory($event.value)"
        >
          <mat-option
            *ngFor="let option of categoryOptions"
            [disabled]="option.disabled"
            [value]="option"
            >{{ option }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <app-filter-group
      (selectionChanged)="filterHandle($event)"
      [newFiltersOptions]="newGroupFilters"
      [filters]="outputFilters"
      [defaultFilterOption]="defaultFilterOption"
      [addLeftToRightDisableFunctionality]="addLeftToRightDisableFunctionality"
      [resetOtherFiltersBasedCurrentSelection]="
        resetOtherFiltersBasedCurrentSelection
      "
      [isDisabledMenu]="!selectedCategory"
    ></app-filter-group>
  </div>

  <div style="display: flex; justify-content: space-between">
    <div style="display: flex; align-items: center; gap: 10px">
      <b>Active Filters</b> :
      <mat-chip-set #chipGrid>
        @for (activeFilter of activeFilters; track activeFilter) {
          <mat-chip-row (removed)="remove(activeFilter)">
            {{ viewByReverseMapper[activeFilter] }}
            <button matChipRemove [attr.aria-label]="'remove ' + activeFilter">
              <mat-icon style="color: #ffff">cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-set>
    </div>
    <div>
      <!-- <button mat-raised-button (click)="resetPage()" [disabled]="!isReset">
        Reset Revised PE
      </button> -->
    </div>
  </div>

  <div style="margin-top: 1rem" class="peDecomTableContainer">
    <table
      *ngIf="!tableDataLoader"
      mat-table
      [dataSource]="dataSource"
      class="peDecomTable"
    >
      <ng-container matColumnDef="retailer">
        <th mat-header-cell *matHeaderCellDef>
          {{ selectedRetailer === "TT" ? "Region" : "Retailer" }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element["retailer"] }}</td>
        <td mat-footer-cell *matFooterCellDef>Total</td>
      </ng-container>

      <!-- Brand Column -->
      <ng-container matColumnDef="Category">
        <th mat-header-cell *matHeaderCellDef>Brand</th>
        <td mat-cell *matCellDef="let element">{{ element["Category"] }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- SKU Column -->
      <ng-container matColumnDef="BrandPackVariant">
        <th mat-header-cell *matHeaderCellDef>SKU</th>
        <td mat-cell *matCellDef="let element">
          {{ element["BrandPackVariant"] }}
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="PackContents">
        <th mat-header-cell *matHeaderCellDef>Current Price</th>
        <td mat-cell *matCellDef="let element">
          {{ element["PackContents"] | number: "1.2-2" }}
        </td>
        <td mat-footer-cell *matFooterCellDef>{{ getCurrentPriceAvg() }}</td>
      </ng-container>

      <ng-container matColumnDef="gross_elasticity">
        <th mat-header-cell *matHeaderCellDef>Gross Elasticity</th>
        <td mat-cell *matCellDef="let element">
          {{ element["PE"]?.toFixed(2) ?? 0 }}
        </td>
        <td mat-footer-cell *matFooterCellDef>
          {{ getGrossElasticityAverage() }}
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="revised_pe">
        <th mat-header-cell *matHeaderCellDef>Revised PE</th>
        <td mat-cell *matCellDef="let element">
          <input
            #revisedPE
            (input)="
              getThePEValueForSKU(
                revisedPE.value,
                element['SKU'],
                element['Chain']
              )
            "
            class="revisedPE-input"
            type="number"
            [defaultValue]="element['Revised PE']"
          />
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container> -->

      <ng-container matColumnDef="gross_internal">
        <th mat-header-cell *matHeaderCellDef>
          <div
            style="width: 350px; display: flex; justify-content: space-between"
          >
            <div>Gross Internal</div>
            <div>Net Elasticity</div>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            style="
              width: 350px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div style="margin-right: 1rem">
              {{ element["gross_internal"]?.toFixed(2) ?? 0 }}
            </div>
            <div>
              <div class="progress reverse-bar">
                <div
                  class="progress-done"
                  [ngStyle]="{
                    'width.%':
                      math.abs(element['gross_internal'] * maxRange) ?? 0,
                    background: '#24B8C9',
                    'border-radius':
                      math.abs(element['net_elasticity']) > 10
                        ? ' 20px 0 0 20px'
                        : '10px 0 0 10px'
                  }"
                ></div>
              </div>
            </div>
            <div>
              <div class="progress corner-left">
                <div
                  class="progress-done"
                  [ngStyle]="{
                    'width.%':
                      math.abs(element['net_elasticity'] * maxRange) ?? 0,
                    'border-radius':
                      math.abs(element['net_elasticity']) > 10
                        ? '0 20px 20px 0'
                        : '0 10px 10px 0'
                  }"
                ></div>
              </div>
            </div>
            <div style="margin-left: 1rem">
              {{ element["net_elasticity"]?.toFixed(2) ?? 0 }}
            </div>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="manufacturer_walk_rate">
        <th mat-header-cell *matHeaderCellDef>Manufacturer Walk Rate</th>
        <td
          mat-cell
          *matCellDef="let element"
          style="
            display: flex;
            justify-content: space-around;
            align-items: center;
          "
        >
          <div class="progress rounded-corner">
            <div
              class="progress-done"
              [ngStyle]="{
                'width.%': math.abs(element['walkrate']) ?? 0,
                'border-radius':
                  math.abs(element['walkrate']) > 10 ? '20px' : '10px'
              }"
            ></div>
          </div>
          <div>
            {{ (element["walkrate"]?.toFixed(2) ?? 0) + "%" }}
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>
    <div
      *ngIf="tableDataLoader"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-left: auto;
        margin-right: auto;
        height: 250px;
      "
    >
      <mat-progress-spinner diameter="70" color="primary" mode="indeterminate">
      </mat-progress-spinner>
      <h4 style="font-weight: bold; margin-top: 10px">Loading...</h4>
    </div>
  </div>

  <div>
    <button style="float: left" (click)="goBack()" mat-button>
      <mat-icon style="font-size: 20px"> arrow_back </mat-icon>
      <span> Go Back </span>
    </button>

    <button
      (click)="onSave()"
      mat-flat-button
      color="primary"
      style="float: right"
    >
      <mat-icon>download</mat-icon>
      Download .xlsx
    </button>

    <!-- <button
      (click)="updateRevisedPE(false)"
      mat-stroked-button
      color="primary"
      style="float: right; margin-right: 1.5rem"
      [disabled]="!isRevisedColChange"
    >
      Update Revised PE
    </button> -->
  </div>
</mat-card>
